import { View } from "extensions/marionette";

import { _ } from "extensions/underscore";
import Radio from "backbone.radio";
import humanize from "lodash-es/startCase";

import { Sources } from "common/components/typeahead";
import { View as TokenfieldView, Model as TokenfieldModel } from "common/components/tokenfield";
import { typeaheadMixin } from "./typeaheadMixin";

import searchCredentialsTemplate from "./searchCredentials.jst";

const MongoFullObjectID = /^(?=[\da-f]{24}$)(\d+[a-f]|[a-f]+\d)/i;

export const SearchCredentials = View.extend({
    ...typeaheadMixin,
    className: "searchCredentials",
    template: searchCredentialsTemplate,
    
    ui: {
        addNew: "#addNewCredential"
    },
    
    regions: {
        search: ".search-box-cont"
    },
    
    events: {
        "click @ui.addNew": "addNewCredential",
        "change .showInactive": function(event) {
            this.triggerMethod("active:update", { checked: event.target.checked });
        },
        "change .showExpired": function(event) {
            this.triggerMethod("expired:update", { checked: event.target.checked });
        }
    },
    
    addNewCredential(e) {
        e.preventDefault();
        Radio.channel("credentials").trigger("credential:create");
    },
    
    async initTypeahead() {
        const providers = await this.getProvidersModel();
        
        const sourcesCollection = new Sources([
            this.getMerchantsModel(),
            providers,
            this.getProtocolsModel()
        ]);
        
        this.stepsTypeahead = new TokenfieldView({
            collection: sourcesCollection,
            model: new TokenfieldModel({
                autofocus: true,
                minWidth: 440,
                limit: 5,
                createTokensOnBlur: false,
                placeholder: "Search by merchant, provider, protocol, or credential name"
            }),
            
            onTokenBeforeCreate(event) {
                // Populate group for fields that we took not from the typeahead sources
                if (!event.attrs.group) {
                    if (MongoFullObjectID.test(event.attrs.value)) {
                        // If we detect that item is Mongo ObjectID then just open it in the new tab
                        Radio.channel("credentials").trigger("credential:show", event.attrs.value);
                        this.clear();
                        event.preventDefault();
                        return;
                    }
                    event.attrs.group = "display_name";
                }
    
                // Check if we already have any token from the same group inside the input
                const existingTokens = this.getTokens();
                // eslint-disable-next-line unicorn/prefer-array-some
                const hasSameGroupToken = _.any(existingTokens, (t) => !!_.find(existingTokens, (et) => et.group === event.attrs.group));
                if (hasSameGroupToken) {
                    event.preventDefault();
                }
            },
            
            onTokenCreate(event) {
                let addClass;
                let addTitle;
                
                if (event.attrs.group) {
                    addClass = `token-${event.attrs.group}`;
                    addTitle = humanize(event.attrs.group);
                }
                
                if (addClass) {
                    event.relatedTarget.classList.add(addClass);
                }
                
                if (addTitle) {
                    event.relatedTarget.setAttribute("aria-label", addTitle);
                    event.relatedTarget.classList.add("tooltipped");
                    event.relatedTarget.classList.add("tooltipped-n");
                }
            }
        });
        
        this.listenTo(this.stepsTypeahead, "updated", (changedToken, allTokens) => {
            this.triggerMethod("tokens:update", allTokens);
        });
        try {
            this.showChildView("search", this.stepsTypeahead);
        } catch {
            console.error("An error has occurred with `showChildView`.");
        }
    },
    
    onRender() {
        this.initTypeahead();
    }
});
